'use es6';

import Layout from 'DesignData/models/layouts/Layout';
export default class UnifiedLayout extends Layout {
  constructor(props) {
    return super(props);
  }

}